"use client";
import React from "react";
import "./Contact.scss";
import HomeForm from "./HomeForm/HomeForm";
import LazyMap from "../../Map/LazyMap";
import { ReactSVG } from "react-svg";
import { motion } from "framer-motion";
import { fadeUp, defaultViewport } from "@/utils/animations";

const Contact = () => {
  const key = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;

  return (
    <motion.div
      className='home-contact-wrapper baseContainer'
      variants={fadeUp}
      initial="hidden"
      whileInView="visible"
      viewport={defaultViewport}
    >
      <div className="maxWidth flex flex-col gap-[24px]">
        <p className='section-main-header blue-500 '>
          Reach Out to Amherst Supply
        </p>
        <div className='home-contact-sections'>
          <div className='left-form'>
            <HomeForm style='' />
          </div>

          <div className='right-map'>
            <LazyMap apiKey={key} />
            <div className='info-wrapper'>
              <div className='column'>
                <ReactSVG src='/assets/grey-marker-ic.svg' />
                <div className='info-details-wrapper'>
                  <p className='text-small-20 grey-700'>Address</p>
                  <p className='text-mini-14 grey-700 weight-500'>
                    1500 Alma Street, <br />
                    Amherstburg, ON N9V 2Y9
                  </p>
                </div>
              </div>

              <div className='column'>
                <ReactSVG src='/assets/time-ic.svg' />
                <div className='info-details-wrapper'>
                  <p className='text-small-20 grey-700'>Hours</p>

                  <p className='text-mini-14 grey-700 weight-500'>
                    Monday - Friday: 7:30am - 5:30pm
                  </p>
                  <p className='text-mini-14 grey-700 weight-500'>
                    Saturday: 8:00am - 4:00pm
                  </p>
                  <p className='text-mini-14 grey-700 weight-500'>
                    Sunday: Closed
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Contact;
